import styled from 'styled-components';

// CONSTANTS
import colors from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

const { channelCard } = colors;

export const ChannelCardBoxShadow = styled.div`
  &.channel-card {
    position: relative;
    transition: all 0.3s;

    &--hover {
      &:hover {
        cursor: pointer;
        box-shadow: 0 20px 40px ${channelCard.hover.shadow};
      }
    }

    .channel-card__container {
      width: 100%;
      border-radius: 6px;
      transition: all 0.3s;
      padding: 25px;
      min-height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.5;

      &--active {
        opacity: 1;
      }
    }

    .channel-card__addons {
      position: absolute;
      top: 5px;
      left: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      &-item {
        display: flex;

        img {
          height: 24px;
        }

        &:not(:last-of-type) {
          margin-right: 5px;
        }
      }
    }

    .channel-card__not-available {
      position: absolute;
      top: 5px;
      right: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      &-item {
        display: inline-block;
        height: 24px;
        width: 24px;

        img {
          height: 24px;
        }

        &:not(:last-of-type) {
          margin-right: 15px;
        }
      }
    }

    .channel-card__image {
      max-width: 110px;
      max-height: 100%;

      ${breakpoints.down('xs')} {
        max-width: 100%;
      }
    }
  }
`;

export default ChannelCardBoxShadow;
